export enum LogLevel {
  None,
  Errors,
  Debug,
  Trace,
}

const DCAurls: { [key: string]: string } = {
  local: 'https://jmly57rgw1.execute-api.us-east-1.amazonaws.com',
  dev: 'https://jmly57rgw1.execute-api.us-east-1.amazonaws.com',
  prod: 'https://di5gisv68c.execute-api.us-east-1.amazonaws.com',
};

const DCABackendurls: { [key: string]: string } = {
  local: 'https://dca-backend-app-201514097239.us-east1.run.app',
  dev: 'https://api.dev.dca.deloitte.com',
  prod: 'https://api.dca.deloitte.com',
};
// Uncomment above and comment below to revert to cloud backend
// const DCABackendurls: { [key: string]: string } = {
//   local: 'http://localhost:5000',
//   dev: 'http://localhost:5000',
//   prod: 'http://localhost:5000',
// };

const DCAAdminurls: { [key: string]: string } = {
  local: 'https://admin:secret@dcp.deloitte.dcpgreendot.com',
  dev: 'https://admin:secret@dcp.deloitte.dcpgreendot.com/',
  prod: 'https://admin:secret@dcp.deloitte.dcpgreendot.com',
};

const CWBurls = {
  staging: 'https://cloudworkbenchapi.deloitte.com',
  prod: 'https://cloudworkbenchapi.deloitte.com',
};

const DCPurls = 'https://3cm6q63da8.execute-api.us-east-1.amazonaws.com';

// Using this as baseURL for migrated Tangra APIs. To be changed later to use as baseURL for all APIs of TangraBE
const tangraURLs: { [key: string]: string } = {
  prod: 'https://qsp5weyu2a.execute-api.us-east-1.amazonaws.com/V1',
  dev: 'https://jfsjlgmg74.execute-api.us-east-1.amazonaws.com/V1',
  demo: 'https://nihboprpmg.execute-api.us-east-1.amazonaws.com/V1',
  local: 'https://680zrrgno8.execute-api.us-east-1.amazonaws.com/V1',
};

const SocketURL: { [key: string]: string } = {
  prod: 'wss://0zl6fu078i.execute-api.us-east-1.amazonaws.com/staging',
  dev: 'wss://5hloccdggd.execute-api.us-east-1.amazonaws.com/staging',
};

// DCA AI Skills Engine (FastAPI on Cloud Run, fronted by GCP API Gateway).
// In production the frontend should hit the API Gateway URL (with an API key)
// rather than the raw Cloud Run URL — but the Cloud Run URL is kept here as a
// dev fallback and so existing callers can swap by changing one constant.
// Override at build time with REACT_APP_DCA_AI_ENGINE_URL on Amplify.
const DcaAiEngineUrls: { [key: string]: string } = {
  local: 'https://dca-ai-skills-backend-201514097239.us-east1.run.app',
  dev: 'https://dca-ai-skills-backend-201514097239.us-east1.run.app',
  prod: 'https://dca-ai-skills-backend-201514097239.us-east1.run.app',
};

/**
 * Setting BaseUrl
 *
 * If env vars have been set by envconsul it will use that.
 * Otherwise it will look for .env file with the REACT_APP_API_ENV, if not present it will default to localhost
 * */
const targetEnv = process.env.REACT_APP_API_ENV || 'dev';

const DCABaseUrl = DCAurls[targetEnv];
const DCABackendBaseUrl = DCABackendurls[targetEnv];
const TangraDCABaseUrl = DCAurls[targetEnv];
const CwbBaseurls = CWBurls;
const tangraBaseURL = tangraURLs[targetEnv];
const socketBaseUrl = SocketURL[targetEnv];
const dcaAdmin = DCAAdminurls[targetEnv];
const tangraBaseLocalURL = tangraURLs[targetEnv];
// Accept either env-var name. REACT_APP_DCA_AI_URL is what the existing
// AiEngine / SkillsAssistant components historically read; the longer
// REACT_APP_DCA_AI_ENGINE_URL is kept as an alias.
const dcaAiEngineBaseUrl =
  process.env.REACT_APP_DCA_AI_URL ||
  process.env.REACT_APP_DCA_AI_ENGINE_URL ||
  DcaAiEngineUrls[targetEnv];

export const AppSettings = {
  DCAserver: DCABaseUrl,
  DCABackendServer: DCABackendBaseUrl,
  TangraDCAserver: TangraDCABaseUrl,
  cwbServer: CwbBaseurls.staging,
  DCPServer: DCPurls,
  tangraURL: tangraBaseURL,
  logging: { logLevel: LogLevel.Errors },
  socketURL: socketBaseUrl,
  DCAAdmin: dcaAdmin,
  localURL: tangraBaseLocalURL,
  SAPBE: 'https://sapapi.dca.deloitte.com/dmap',
  prometheus: 'https://pet-clinic-app.dcacloudsre.com',
  faultInjectionStatus: 'https://pet-clinic-app.dcacloudsre.com',
  dcaAiEngine: dcaAiEngineBaseUrl,
};

export const QuickLinksURL = {
  deloitte: 'https://www.deloitte.com/',
  deloitteCloudEngineering:
    'https://www2.deloitte.com/global/en/pages/strategy-operations/solutions/cloud-engineering.html',
  cmsPortal: 'https://www.cms.com/',
  swagger: 'https://app.swaggerhub.com/apis-docs/soadity/icp-tangra/1.0.0#/',
  dcpKaibur: 'https://dcp.deloitte.dcpgreendot.com/',
  runTalkQE: 'http://talkqe-alb-2019878816.us-east-1.elb.amazonaws.com/TWB/#/',
  runCofta:
    'https://appstream2.us-east-1.aws.amazon.com/authenticate?parameters=eyJ0eXBlIjoiRU5EX1VTRVIiLCJleHBpcmVzIjoiMTY2MjU2OTkxMSIsImF3c0FjY291bnRJZCI6IjU1NTc2OTc5MTgyNCIsInVzZXJJZCI6ImFrc2hjaG91ZGhhcnlAZGVsb2l0dGUuY29tIiwiY2F0YWxvZ1NvdXJjZSI6InN0YWNrL3Rlc3QyMmF1ZyIsImZsZWV0UmVmIjoiZmxlZXQvZmxlZXQtMjJhdWciLCJhcHBsaWNhdGlvbklkIjoiIiwidXNlckNvbnRleHQiOiIiLCJtYXhVc2VyRHVyYXRpb25JblNlY3MiOiI1NzYwMCJ9&signature=%2BgiavDJQm5jJFiw0yzl%2FEW%2F1ya9ZQCHw%2BJk2UAFa7rU%3D',
  splunkDashboard: 'http://splunk-lb-1636059872.us-east-1.elb.amazonaws.com',
  splunkDashboardGCP: 'http://34.107.238.204',
};
